import React, { useEffect, useMemo, useState } from 'react'
import KapalService from '../../../../services/kapal/KapalService'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import { AsyncPaginate } from 'react-select-async-paginate'
import { FaMagnifyingGlass } from 'react-icons/fa6'
import SweetAlert from 'react-bootstrap-sweetalert'
import UploadService from '../../../../services/transaksi/UploadService'
import { getCurrentDateTimeFormatted } from '../../../../utilities/Utils'

const ModalInspeksi = ({ showInspeksi, handleCloseInspeksi, dataPpmKapal, dataDisposisi, reloadList, isEdit }) => {
    let kapalService = useMemo(() => new KapalService(), [])
    let uploadService = useMemo(() => new UploadService(), [])

    const [listDokInspeksi, setListDokInspeksi] = useState([])
    const [inspeksiDok, setInspeksiDok] = useState([])
    const [dataInspeksi, setDataInspeksi] = useState(null)

    const [valueMekanismeInspeksiOpt, setValueMekanismeInspeksiOpt] = useState(null)
    async function loadOptionMekanismeInspeksi(search, loadedOption, { page }) {
        const options = [
            {
                value: '1',
                label: 'Inspeksi Di Tempat'
            },
            {
                value: '2',
                label: 'Inspeksi Jarak Jauh'
            }
        ]
        return {
            options: options,
        }
    }
    const onChangeMekanismeInspeksiOpt = e => {
        setValueMekanismeInspeksiOpt(e)
    }

    useEffect(() => {
        if (!dataPpmKapal) return
        const fetchAllData = async () => {
            try {
                const resRefDok = await kapalService.listJenisDokKapal(null, 'lhp', 0, 10)
                setListDokInspeksi(resRefDok.data.data)

                const resInspeksi = await kapalService.getInspeksiData(dataPpmKapal.nomorAjuKapal)
                if (resInspeksi) {
                    setDataInspeksi(resInspeksi.data)
                    setValueTglInspeksi(resInspeksi.data.tglInspeksi)

                    const resInspeksiDok = await kapalService.listInspeksiDokByIdInspeksi(resInspeksi.data.idInspeksi)
                    setInspeksiDok(resInspeksiDok.data.data)

                    const optionMekanisme = [{ value: '1', label: 'Inspeksi Di Tempat' }, { value: '2', label: 'Inspeksi Jarak Jauh' }]
                    setValueMekanismeInspeksiOpt(optionMekanisme.find(option => option.value === resInspeksi.data.tipeInspeksi))
                }

            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, dataPpmKapal])

    const [valueTglInspeksi, setValueTglInspeksi] = useState(getCurrentDateTimeFormatted())
    const onChangeTglInspeksi = e => {
        setValueTglInspeksi(e.target.value)
    }

    const handleChangeInspeksiDok = (id, e) => {
        const file = e.target.files[0]
        if (file) {
            setInspeksiDok((prev) => {
                const existing = prev.find((item) => item.idJenisDok === id);
                const newFileName = file.name.replaceAll(" ", "-")
                const renamedFile = new File([file], newFileName, {
                    type: file.type
                })
                if (existing) {
                    return prev.map((item) =>
                        item.idJenisDok === id ? { ...item, dokNameOri: renamedFile.name, dokPath: process.env.REACT_APP_API_URL_FILE + '/view/' + dataPpmKapal.nomorAjuKapal + '/' + renamedFile.name, dokFile: renamedFile } : item
                    );
                } else {
                    return [...prev, { idJenisDok: id, dokNameOri: renamedFile.name, dokPath: process.env.REACT_APP_API_URL_FILE + '/view/' + dataPpmKapal.nomorAjuKapal + '/' + renamedFile.name, dokFile: renamedFile }];
                }
            });

        }
    }

    const [showConfirmProses, setShowConfirmProses] = useState(false)
    const handleCloseConfirmProses = () => setShowConfirmProses(false)
    const handleClickConfirmProses = () => {
        setShowConfirmProses(true)
    }

    const [loadingProses, setLoadingProses] = useState(false)
    const [showProsesSuccess, setShowProsesSuccess] = useState(false)
    const [showProsesFailed, setShowProsesFailed] = useState(false)

    const handleCloseSuccess = () => {
        setShowProsesSuccess(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleCloseFailed = () => {
        setShowProsesFailed(false)
        // reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickProses = async () => {
        setLoadingProses(true)
        try {
            if (checkKelengkapan()) {
                let jsonInspeksi = {
                    ...dataInspeksi,
                    nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                    tglInspeksi: valueTglInspeksi,
                    tipeInspeksi: valueMekanismeInspeksiOpt.value,
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
                const resSaveInspeksi = await kapalService.saveInspeksi(jsonInspeksi)
                if (resSaveInspeksi.data.kode === '200') {
                    //ev permohonan dok
                    const idInspeksi = resSaveInspeksi.data.id

                    inspeksiDok.map(async (insDok) => {
                        let newInsDok = {
                            ...insDok,
                            idInspeksi: idInspeksi,
                            nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                            createdBy: localStorage.getItem('userId'),
                            createdDate: new Date()
                        }
                        await kapalService.saveInspeksiDok(newInsDok)

                        await uploadService.uploadFile(dataPpmKapal.nomorAjuKapal, insDok.dokFile)
                        // console.log(resUpload)
                    })

                    let dataDispo = {
                        ...dataDisposisi,
                        noTugas: 'Inspeksi-' + dataPpmKapal.nomorAjuKapal,
                        tglTugas: new Date()
                    }
                    await kapalService.savePenugasan(dataDispo)

                    setShowConfirmProses(false)
                    setShowProsesSuccess(true)
                } else {
                    setShowConfirmProses(false)
                    setShowProsesFailed(true)
                }
            } else {
                setShowConfirmProses(false)
                setShowProsesFailed(true)
            }
        } catch (error) {
            setShowConfirmProses(false)
            setShowProsesFailed(true)
        }
        setLoadingProses(false)
    }

    const handleClickClose = () => {
        // setHasilEvpDok([])
        // setValueCatatan('')
        // setValueKesimpulanOpt(null)
        handleCloseInspeksi()
    }

    const [base64String, setBase64String] = useState(null)
    const [showOpenPreview, setShowOpenPreview] = useState(false)
    const handleClickPreview = async (dokPath) => {
        setBase64String(dokPath)
        setShowOpenPreview(true)
    }
    const handleClosePreview = () => {
        setBase64String(null)
        setShowOpenPreview(false)
    }

    const [kelengkapan, setKelengkapan] = useState({})
    const checkKelengkapan = () => {
        const checkKelengkapan = {}
        if (!valueTglInspeksi) checkKelengkapan.tglInspeksi = 'Tanggal Inspeksi Wajib Diisi'
        if (!valueMekanismeInspeksiOpt) checkKelengkapan.mekanismeInpeksi = 'Mekanisme Inspeksi Wajib Diisi'

        setKelengkapan(checkKelengkapan)
        return Object.keys(checkKelengkapan).length === 0
    }

    return (
        <>
            <Modal
                show={showInspeksi}
                onHide={handleCloseInspeksi}
                size='xl'
                centered
            >
                <Modal.Header>
                    <Modal.Title><h5>Inspeksi</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju Kapal</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPpmKapal.nomorAjuKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.namaKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Ukuran Kapal</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.ukuranKapal} disabled />
                                    </Col>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">GT</Form.Label>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Jenis Kapal</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type='text' placeholder="alamat" className="form-control-sm" value={dataPpmKapal.jenisKapal === '1' ? 'Penangkap' : 'Pengangkut'} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Inspeksi <span className='text-danger'> *</span></Form.Label>
                                    <Col sm="2">
                                        <Form.Control type='date' placeholder="Tanggal Inspeksi" className="form-control-sm" value={valueTglInspeksi} onChange={onChangeTglInspeksi} />
                                    </Col>
                                </Form.Group>
                            </Form>
                            {kelengkapan.tglInspeksi && <div className="text-danger">{kelengkapan.tglInspeksi}</div>}
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Mekanisme Inspeksi <span className='text-danger'> *</span></Form.Label>
                                    <Col sm="3">
                                        <AsyncPaginate
                                            loadOptions={loadOptionMekanismeInspeksi}
                                            value={valueMekanismeInspeksiOpt}
                                            getOptionValue={(option) => option.value}
                                            getOptionLabel={(option) => option.label}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeMekanismeInspeksiOpt}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                            {kelengkapan.mekanismeInpeksi && <div className="text-danger">{kelengkapan.mekanismeInpeksi}</div>}
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <h6>Dokumen Hasil Inspeksi</h6>
                        </div>
                    </div>
                    {
                        listDokInspeksi &&
                        listDokInspeksi.map((dokwajib, idx) => {
                            const current = inspeksiDok.find((h) => h.idJenisDok === dokwajib.id)
                            return (
                                <>
                                    <div className='row' key={dokwajib.id || idx}>
                                        <div className='col-12'>
                                            <Form>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">{dokwajib.jenisDokKapal}</Form.Label>
                                                    <Col sm="6">
                                                        {
                                                            current?.dokPath ? <>
                                                                <Form.Label column sm="12" className="control-label align-self-center mb-0" htmlFor="searchNib">{current.dokNameOri}</Form.Label>
                                                                <Form.Control type='file' placeholder="file" className="form-control-sm" onChange={e => handleChangeInspeksiDok(dokwajib.id, e)} />
                                                            </>
                                                                :
                                                                <Form.Control type='file' placeholder="file" className="form-control-sm" onChange={e => handleChangeInspeksiDok(dokwajib.id, e)} />
                                                        }
                                                    </Col>
                                                    <Col sm="2">
                                                        {current?.dokPath && (<Button size='sm' variant='info' onClick={() => handleClickPreview(current.dokPath)} ><FaMagnifyingGlass /> Preview Dok</Button>)}
                                                    </Col>
                                                </Form.Group>
                                            </Form>
                                        </div>
                                    </div>
                                </>
                            )
                        })
                    }
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && dataPpmKapal.kodeStatus === '023' && <Button variant="primary" size="sm" onClick={() => handleClickConfirmProses()}>Proses</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            <PreviewPdf showOpenPreview={showOpenPreview} handleClosePreview={handleClosePreview} base64string={base64String} />
            {
                showConfirmProses &&
                <SweetAlert
                    title="Simpan Inspeksi?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingProses ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProses}
                    onCancel={handleCloseConfirmProses}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingProses}
                    reverseButtons
                >
                    {loadingProses && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data  Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

const PreviewPdf = ({ showOpenPreview, handleClosePreview, base64string }) => {
    // const pdfUrl = 'data:application/pdf;base64,' + base64string

    return (
        <>
            <Modal show={showOpenPreview} onHide={handleClosePreview} size='xl'>
                <iframe
                    src={base64string}
                    title='Preview PDF'
                    width="100%"
                    height="800px"
                ></iframe>
            </Modal>
        </>
    )
}

export default ModalInspeksi